import React from "react";
import c from "./ManualControlBtns.module.css";

export default function ManualControlBtns({
  isOn,
  switchOnHandler,
  switchOffHandler,
}: {
  isOn: boolean;
  switchOnHandler: () => Promise<void>;
  switchOffHandler: () => Promise<void>;
}): React.ReactElement {
  return (
    <div className={c.container}>
      <button
        className={c.btn + " " + (!isOn ? c.btnSuccess : c.btnSecondary)}
        disabled={isOn}
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick={async (e) => {
          e.stopPropagation();
          await switchOnHandler();
        }}
      >
        ON
      </button>
      <button
        className={c.btn + " " + (isOn ? c.btnDanger : c.btnSecondary)}
        disabled={!isOn}
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick={async (e) => {
          e.stopPropagation();
          await switchOffHandler();
        }}
      >
        OFF
      </button>
    </div>
  );
}
